export function groupArticles(items, category = "Alle", term = "") {
  const search = String(term || "").trim().toLocaleLowerCase("de-CH"), groups = new Map()
  for (const item of items) {
    const key = item.productGroupId || (item.familyName ? JSON.stringify([item.category, item.familyName.toLocaleLowerCase("de-CH")]) : item.id)
    if (!groups.has(key)) groups.set(key, { key, name: item.familyName || item.name, category: item.category, grouped: !!item.familyName, variants: [] })
    groups.get(key).variants.push(item)
  }
  return [...groups.values()]
    .filter(group => (category === "Alle" || group.category === category) && (!search || group.variants.some(item => [item.name, item.familyName, item.variantName, item.sourceId].some(value => String(value || "").toLocaleLowerCase("de-CH").includes(search)))))
    .map(group => ({ ...group,
      variants: [...group.variants].sort((a, b) => (a.variantName || a.name).localeCompare(b.variantName || b.name, "de-CH") || String(a.sourceId).localeCompare(String(b.sourceId))),
      imagePath: (group.variants.find(item => item.productImagePath) || {}).productImagePath || (group.variants.find(item => item.imagePath) || {}).imagePath,
      priceCents: Math.min(...group.variants.map(item => item.priceCents)), differentPrices: new Set(group.variants.map(item => item.priceCents)).size > 1,
    })).sort((a, b) => a.name.localeCompare(b.name, "de-CH"))
}

export function cartReview(lines, current) {
  const sources = new Map(current.map(item => [String(item.sourceId), item]))
  return lines.map(before => {
    const article = sources.get(String(before.sourceId)), after = article ? { ...article, quantity: before.quantity } : null
    return { before, after, changed: !after || before.id !== after.id || before.sourceDigest !== after.sourceDigest || before.overrideRevision !== after.overrideRevision || before.priceCents !== after.priceCents || (before.groupRevision || 0) !== (after.groupRevision || 0) || (before.productGroupId || "") !== (after.productGroupId || "") }
  })
}

export function filterVariants(variants, selection = {}) {
  return variants.filter(row => Object.entries(selection).every(([key, value]) => !value || (row.variantAttributes || {})[key] === value))
}
export function variantFacets(variants, selection = {}) {
  const sizes = { XXS: 0, XS: 1, S: 2, M: 3, L: 4, XL: 5, XXL: 6, '2XL': 6, XXXL: 7, '3XL': 7, '4XL': 8, '5XL': 9 }
  const compare = (key, a, b) => key === "size" ? ((sizes[a.split('/')[0]] == null ? 99 : sizes[a.split('/')[0]]) - (sizes[b.split('/')[0]] == null ? 99 : sizes[b.split('/')[0]])) || a.localeCompare(b, "de-CH") : a.localeCompare(b, "de-CH", { numeric: true })
  return Object.entries({ color: "Farbe", size: "Grösse", flavour: "Geschmack", content: "Inhalt" }).map(([key, name]) => {
    const candidates = filterVariants(variants, { ...selection, [key]: "" })
    const options = [...new Set(variants.map(row => (row.variantAttributes || {})[key]).filter(Boolean))].sort((a, b) => compare(key, a, b)).map(value => ({ value,
      available: candidates.some(row => (row.variantAttributes || {})[key] === value) }))
    return { key, name, options }
  }).filter(facet => facet.options.length > 1)
}
export function colorSwatches(value) {
  const colors = { schwarz: "#202124", black: "#202124", weiss: "#ffffff", weiß: "#ffffff", white: "#ffffff", blau: "#2164b0", blue: "#2164b0", dunkelblau: "#1d3557",
    grau: "#92969b", gray: "#92969b", grey: "#92969b", dunkelgrau: "#51545a", hellgrau: "#d5d7da", grün: "#2e854a", green: "#2e854a", rot: "#cb3444", rosa: "#eaaaaf",
    pink: "#d94f91", gelb: "#e8c847", orange: "#eb913f", türkis: "#35aeb5", violett: "#885baf", lila: "#885baf", neon: "#c6ee52", beige: "#d2c5ad", braun: "#825f48", 'washed grau': "#969a98" }
  return String(value).split("/").map(part => colors[part.toLowerCase()]).filter(Boolean)
}

export function productTone(name) {
  if (/\b(?:bra|hoodie|shirt|hose|leggins|leggings|shorts|tank top|joggers)\b/i.test(name)) return "blue"
  if (/riegel|\bbar\b|chocolate|chips|nuss|nuts|pudding/i.test(name)) return "rose"
  if (/wasser|water|drink|feelfood|vitamin well|shake|kaffee|coffee|tea|iso tonic/i.test(name)) return "mint"
  return "neutral"
}
export function productIcon(name) {
  const tone = productTone(name)
  return { blue: "mdi-tshirt-crew-outline", rose: "mdi-food-variant", mint: "mdi-bottle-soda-outline", neutral: "mdi-package-variant-closed" }[tone]
}
